import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Header from "./components/Header/Header";
import OrganizationsTable from "./components/OrganizationsTable";

function OrganizationsListMain() {
  const { i18n } = useTranslation();
  const isHebrew = useMemo(() => i18n.language === "heb", [i18n.language]);

  return (
    <div
      className={`flex-1 min-h-0 flex flex-col ${
        isHebrew ? "rounded-tl-[32px]" : "rounded-tr-[32px]"
      }`}
    >
      <Header />
      <OrganizationsTable />
    </div>
  );
}

export default OrganizationsListMain;
